import React from 'react';

const LocateUserBtn = props => {
  return (
    <div
    onClick={props.geolocateUser}
      style={{
        position: 'absolute',
        bottom: 50,
        right: 30,
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#fff',
        color: '#333',
        WebkitBoxShadow: "2px 3px 5px 0px rgba(0,0,0,0.19)",
        MozBoxShadow: "2px 3px 5px 0px rgba(0,0,0,0.19)",
        boxShadow: "2px 3px 5px 0px rgba(0,0,0,0.19)",
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
      }}>
      {
        props.isLoading ?
        <img
          style={{
            width: 30,
            height: 20,
          }}
          alt='locate'
          src={require('../../assets/load.gif')}
        /> :
        <img
          style={{
            width: 22,
            height: 22,
          }}
          alt='locate'
          src={require('../../assets/icons/set_ico-geoloc.png')}
        />
      }
    </div>
  );
};

export default LocateUserBtn;
